<form class="search-container h-full">
  <div class="custom-search-wrapper flex items-center w-full">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      class="bg-transparent text-base-content caret-base-content text-ellipsis border-none grow text-md p-2 focus:outline-none"
      id="toolbar-search-box"
      type="text"
      placeholder="Search for anything in documents and data"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      [matAutocompleteConnectedTo]="origin"
      autocomplete="off"
      matAutocompleteOrigin
      #origin="matAutocompleteOrigin"
      [disabled]="disabled" />

    <mat-autocomplete
      class="seach-box-panel"
      (opened)="onOpened()"
      autoActiveFirstOption
      #auto="matAutocomplete"
      [displayWith]="displayFn">
      <ng-container>
        @if (exactTransactionMatch$ | async; as exactTransactionMatch) {
          <mat-option class="full-text-search-option" [value]="exactTransactionMatch">
            Go to {{ exactTransactionMatch.title }}
          </mat-option>
        }

        <ng-container *permissions="[Permission.READ_TEXT_SEARCH]">
          <mat-option class="full-text-search-option" [value]="fullTextResult">
            @if (text$ | async; as text) {
              Search documents for "{{ text | truncate: 50 }}"
            } @else {
              Search in documents
            }
          </mat-option>

          @if (results?.recentSearches?.length) {
            <semeris-search-result-header
              (click)="close()"
              title="Recent searches"
              [loading]="loading"
              [action]="'Go to Text Search'"
              [actionLink]="['/', SemerisRoutes.search.documentSearch]"
              [actionQueryParams]="{ q: control.value }"></semeris-search-result-header>
          }

          @for (item of results?.recentSearches; track item?.item) {
            <mat-option class="option-with-details" [value]="item">
              <semeris-search-result-item
                [item]="item"
                [term]="control.value"
                (close)="close()"></semeris-search-result-item>
            </mat-option>
          }
        </ng-container>

        @if (results?.transactions?.length) {
          <semeris-search-result-header
            (click)="close()"
            title="Deals"
            [loading]="loading"
            [action]="results?.transactions?.length ? searchHint : 'Go to Deals'"
            [actionLink]="['/', SemerisRoutes.dealFilter.root, SemerisRoutes.dealFilter.filter]"
            [actionQueryParams]="
              results?.transactions?.length
                ? { transactions: control.value, preserve: 'true' }
                : { defaultFilters: 'true' }
            "></semeris-search-result-header>
        }

        @for (item of results?.transactions; track item?.item?.transactionId) {
          <mat-option class="clo" [value]="item">
            <semeris-transaction-result-item
              [item]="item"
              [term]="control.value"
              (close)="close()"
              (add)="onAddToCompare($event)"
              (remove)="onRemoveFromComparison($event)"></semeris-transaction-result-item>
          </mat-option>
        }

        @if (results?.datapoints?.length) {
          <semeris-search-result-header
            title="Datapoints"
            (click)="close()"
            [loading]="loading"
            [action]="results?.datapoints?.length ? searchHint : 'Go to Datapoints'"
            [actionLink]="['/', SemerisRoutes.datapoint.root]"
            [actionQueryParams]="{
              search: results?.datapoints?.length ? control.value : '',
            }"></semeris-search-result-header>
        }

        @for (item of results?.datapoints; let index = $index; track item.title + index) {
          <mat-option class="option-with-details" [value]="item">
            <semeris-search-result-item
              class="with-icon"
              [item]="item"
              [term]="control.value"
              (marketCompare)="onMarketCompareDatapoint($event)"
              (formula)="close()"
              (close)="close()"></semeris-search-result-item>
          </mat-option>
        }

        <ng-container *permissions="[Permission.READ_MARKET_COMPARE]">
          @if (results?.definedTerms?.length) {
            <semeris-search-result-header title="Defined terms"> </semeris-search-result-header>
          }

          @for (item of results?.definedTerms; track item?.item) {
            <mat-option class="option-with-details" [value]="item">
              <semeris-search-result-item
                [item]="item"
                [term]="control.value"
                (marketCompare)="onMarketCompareDefinedTerm($event)"></semeris-search-result-item>
            </mat-option>
          }

          @if (results?.topics?.length) {
            <semeris-search-result-header
              title="Topics"
              (click)="close()"
              [loading]="loading"
              [action]="results?.topics?.length ? searchHint : 'Go to Topics'"
              [actionLink]="['/', SemerisRoutes.topic.root]"
              [actionQueryParams]="{
                search: results?.topics?.length ? control.value : '',
              }"></semeris-search-result-header>
          }

          @for (item of results?.topics; track item?.item.id) {
            <mat-option class="option-with-details" [value]="item">
              <semeris-search-result-item
                class="with-icon"
                (toggle)="onToggleTopic(item)"
                [item]="item"
                [term]="control.value"></semeris-search-result-item>
            </mat-option>
          }
        </ng-container>

        @if (results?.checklists?.length) {
          <semeris-search-result-header
            (click)="close()"
            title="Checklists"
            [loading]="loading"
            [action]="results?.checklists?.length ? searchHint : 'Go to Checklists'"
            [actionLink]="['/', SemerisRoutes.checklist.root]"
            [actionQueryParams]="{
              search: results?.checklists?.length ? control.value : '',
            }"></semeris-search-result-header>
        }

        @for (item of results?.checklists; track item?.item?.id) {
          <mat-option class="option-with-details" [value]="item">
            <semeris-search-result-item
              class="with-icon"
              [item]="item"
              [term]="control.value"></semeris-search-result-item>
          </mat-option>
        }

        @if (results?.managers?.length) {
          <semeris-search-result-header
            (click)="close()"
            title="Managers"
            [loading]="loading"
            action="Go to Managers"
            [actionLink]="['/', SemerisRoutes.managers.root]"></semeris-search-result-header>
        }

        @for (item of results?.managers; let index = $index; track `${item?.item.id}-${index}`) {
          <mat-option class="option-with-details" [value]="item">
            <semeris-search-result-item [item]="item" [term]="control.value"></semeris-search-result-item>
          </mat-option>
        }

        <mat-option semerisHelpTrigger helpId="toolbar-search.html" class="help-option">
          <div>Learn more about Toolbar Search <mat-icon color="accent">help_outline</mat-icon></div>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </div>
</form>
